"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployerApplicationForm = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var main_1 = require("../../../../reducers/slices/main");
var form_validation_1 = require("./form_validation");
var create_employer_1 = require("../../../../api/calls/jobs/create_employer");
var validateForm_1 = require("../../../../helpers/validateForm");
var general_1 = require("../../../../helpers/general");
var ConfirmationMessage = function (props) {
    var name = props.name;
    return (react_1.default.createElement("div", { className: "flex flex-col gap-5" },
        react_1.default.createElement("div", null,
            "You have registered as an employer with the company name ",
            react_1.default.createElement("span", { className: "text-primary font-semibold" }, name),
            "."),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null, "You'll be able to post jobs, find candidates and manage your listings."),
            react_1.default.createElement("div", null, "Please sign-in with the credentials you provided to complete your profile and start posting!")),
        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Sign In as Employer", backgroundColor: "bg-secondary", size: "small", onClick: function () { return (0, general_1.redirectToSocialMediaPage)("https://skyjobs.biz/employer/login"); } })));
};
var EmployerApplicationForm = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useReducer)(form_validation_1.formReducer, form_validation_1.initialState), formState = _a[0], formDispatch = _a[1];
    var _b = (0, react_1.useState)(false), formIsValid = _b[0], setFormIsValid = _b[1];
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var onChange = function (_a) {
        var _b;
        var field = _a.field, value = _a.value;
        formDispatch({ type: "SET_FIELD", field: field, value: value });
        var formData = __assign(__assign({}, formState), (_b = {}, _b[field] = __assign(__assign({}, formState[field]), { value: value, touched: true }), _b));
        validate(formData);
    };
    var isFormValid = function (props) {
        var form = props.form, errors = props.errors;
        var hasErrors = Object.keys(errors).length > 0;
        if (hasErrors)
            return setFormIsValid(false);
        var result = Object.values(form).some(function (field) { return field.required && !field.value; });
        setFormIsValid(!result);
    };
    var validate = function (form) {
        var errors = {};
        if (!form.name.value && form.name.touched) {
            errors.name = "Company Name is required";
        }
        if (!form.site_url.value && form.site_url.touched) {
            errors.site_url = "Website URL is required";
        }
        if (!form.contact_name.value && form.contact_name.touched) {
            errors.contact_name = "Contact Name is required";
        }
        if (form.email.touched) {
            if (!form.email.value) {
                errors.email = "Email is required";
            }
            else if (!(0, validateForm_1.validateEmail)(form.email.value)) {
                errors.email = "Email is invalid";
            }
        }
        if (!form.password.value && form.password.touched) {
            errors.password = "Password is required";
        }
        isFormValid({ form: form, errors: errors });
        formDispatch({ type: "SET_ERROR", errors: errors });
    };
    var onSubmit = function () {
        setIsLoading(true);
        var requestPayload = {
            name: formState.name.value,
            site_url: formState.site_url.value,
            contact_name: formState.contact_name.value,
            email: formState.email.value,
            password: formState.password.value,
        };
        (0, create_employer_1.create_employer)(requestPayload)
            .then(function (response) {
            setIsLoading(false);
            if (response.success === true) {
                dispatch((0, main_1.setContentModal)({
                    title: "Sign Up Successful",
                    content: react_1.default.createElement(ConfirmationMessage, { name: formState.name.value }),
                }));
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Sign-up Error",
                    messages: ["There was a sign-up error. Please try again later."],
                }));
            }
        })
            .catch(function (error) {
            setIsLoading(false);
            dispatch((0, main_1.setMessageModal)({
                title: "Sign-up Error",
                messages: ["There was a sign-up error. Please try again later."],
            }));
        });
    };
    return (react_1.default.createElement("div", { className: "flex flex-col w-full gap-5" },
        react_1.default.createElement("div", { className: "flex flex-col md:flex-row gap-3" },
            react_1.default.createElement("div", { className: "flex flex-col gap-1 w-full md:w-1/2" },
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.name.required, label: "Company Name", size: "small", labelColor: "text-gray-500", errorText: formState.errors.name, value: formState.name.value, onChange: function (value) { return onChange({ field: "name", value: value }); } })),
            react_1.default.createElement("div", { className: "flex flex-col gap-1 w-full md:w-1/2" },
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.site_url.required, label: "Website URL", size: "small", labelColor: "text-gray-500", errorText: formState.errors.site_url, value: formState.site_url.value, onChange: function (value) { return onChange({ field: "site_url", value: value }); } }))),
        react_1.default.createElement("div", { className: "flex flex-col gap-1" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.contact_name.required, label: "Contact Name", size: "small", labelColor: "text-gray-500", errorText: formState.errors.contact_name, value: formState.contact_name.value, onChange: function (value) { return onChange({ field: "contact_name", value: value }); } })),
        react_1.default.createElement("div", { className: "flex flex-col gap-1" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { required: formState.email.required, label: "Email", size: "small", labelColor: "text-gray-500", errorText: formState.errors.email, value: formState.email.value, onChange: function (value) { return onChange({ field: "email", value: value }); } })),
        react_1.default.createElement("div", { className: "flex flex-col gap-1" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { type: "password", required: formState.password.required, label: "Password", size: "small", labelColor: "text-gray-500", errorText: formState.errors.password, value: formState.password.value, onChange: function (value) { return onChange({ field: "password", value: value }); } })),
        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Sign Up as Employer", backgroundColor: "bg-primary", size: "small", loading: isLoading, enabled: formIsValid && !isLoading, onClick: function () { return onSubmit(); } })));
};
exports.EmployerApplicationForm = EmployerApplicationForm;
